export default {
  shareWork: [],
  readMore: 0,
  readLess: 0,
};
